import React from 'react';
import LayoutRow from 'components/content/shared/styling/LayoutRow';
import { TopBarAccountSection } from './TopbarAccountSection';


function Topbar()
{
	return (
		<div className="topbar">
			<LayoutRow className="h100p" style={{ alignItems: 'center' }}>
				<TopBarAccountSection />
			</LayoutRow>
		</div>
	);
};

export default Topbar;